import React from 'react'
import { SubHeading } from 'components/util'

function Caption (props) {
  return (
    <SubHeading {...props} />
  )
}

export default Caption
